import Vue from 'vue';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import './filters';
import vuetify from './plugins/vuetify';

Vue.config.productionTip = false;

import * as FullStory from '@fullstory/browser';

FullStory.init({orgId: '16BDZT'});
Vue.prototype.$FullStory = FullStory;

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
}).$mount('#app');
